import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { get } from 'global/lib/lodash';
import { Card, CardActions, CardActionArea, CardContent, Button, Typography, MobileStepper, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import PageTitle from 'global/components/PageTitle';
import useStyles from './Home.styles';
import { welcomeItems, homeItems } from './homeItems';
import useNavSettings from 'global/hooks/useNavSettings';
import { setHasShownWelcome } from 'redux/actions/view';
import { useUser } from 'global/hooks/useUser';
import { Text } from 'global/components/text';

export default function Home(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const { nav } = useNavSettings();

  const { me } = useUser();
  const hasShownWelcome = useSelector((state) => get(state, 'view.hasShownWelcome'));
  const ProfileLink = (
    <Typography data-testid="home-button-profile-link" variant="button" component={Link} to={`/profile`}>
      Set your name
    </Typography>
  );
  const siteDocs = homeItems(classes, { nav }).filter((f) => f.canDisplay());
  const welcomeDocs = welcomeItems(classes, { nav });
  const maxSteps = siteDocs.length + 2;
  const dispatch = useDispatch();

  useEffect(() => {
    if (get(me, 'first_login') === 1 && !hasShownWelcome) {
      handleClickOpen(-2);
      dispatch(setHasShownWelcome());
    }
  }, [me]);

  const handleClickOpen = (step) => {
    setActiveStep(step + 2);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  useEffect(() => props.changeTitle(<PageTitle Icon={HomeIcon} title="Home" />), []);

  return (
    <div className={classes.content}>
      <Text variant="h5" className={classes.title}>
        <HomeIcon className={classes.icon} />
        Home
      </Text>
      <Text variant="h6" className={classes.sectionHeader}>
        {me !== undefined ? (
          me.name === me.email ? (
            <>
              Welcome {me.email}!<>{ProfileLink}</>
            </>
          ) : (
            `Welcome back ${me.name}!`
          )
        ) : (
          `Welcome`
        )}
      </Text>
      <div className={classes.flex}>
        {siteDocs
          .filter((ni) => ni.canDisplay())
          .map((x, i) => (
            <Card key={i} className={classes.card}>
              <CardActionArea data-testid={`home-card-action-${get(x, 'title')}`} className={classes.cardAction} component={Link} to={x.link}>
                <CardContent>
                  <Typography variant="h5" color="primary" className={classes.flexLabel} gutterBottom>
                    {x.label}
                  </Typography>
                  <Typography variant="body1" component="div">
                    {x.text}
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <Button onClick={() => handleClickOpen(i)} size="small" color="secondary">
                  Learn More
                </Button>
              </CardActions>
            </Card>
          ))}
      </div>
      <Dialog scroll="paper" maxWidth="sm" fullWidth={true} open={open} onClose={handleClose} classes={{ paper: classes.dialogRoot }} aria-labelledby="learn-more-docs">
        <DialogTitle className={classes.flexTitle} id="learn-more-docs">
          {activeStep >= 2 ? siteDocs[activeStep - 2].label : welcomeDocs[activeStep].label}
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="textPrimary">{activeStep >= 2 ? siteDocs[activeStep - 2].longText : welcomeDocs[activeStep].longText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <MobileStepper
            steps={maxSteps}
            position="static"
            variant="dots"
            activeStep={activeStep}
            className={classes.actionStepper}
            nextButton={
              <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                Next
                {<KeyboardArrowRight />}
              </Button>
            }
            backButton={
              <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                {<KeyboardArrowLeft />}
                Back
              </Button>
            }
          />
        </DialogActions>
      </Dialog>
    </div>
  );
}
